import script from "./TransactionCart.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionCart.vue?vue&type=script&setup=true&lang=js"

import "./TransactionCart.vue?vue&type=style&index=0&id=1afe3004&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afe3004"]])

export default __exports__